import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ContratoService, AppContrato } from 'src/app/clientes/crear-contrato/contrato.service';
import { ModuloService } from 'src/app/modulo/modulo.service';
import { TablesService } from 'src/app/generico/tables/tables.service';
import { MensajeService } from 'src/app/generico/servicio/mensaje.service';

@Component({
  selector: 'app-aplicacion-contrato',
  templateUrl: './aplicacion-contrato.component.html',
  styleUrls: ['./aplicacion-contrato.component.scss']
})
export class AplicacionContratoComponent implements OnInit {

  contratoappForm = this.fb.group({
    fk_contrato : [null, [Validators.required]],
    fk_aplicacion : [null, [Validators.required]],
    num_cantidad_usuarios : [null],
    ind_sin_limite : [null],
    ind_full_acceso : [null],

    fk_modulo : [null],
    fk_menu : [null],
    fk_accion : [null],
    short_name : [null, [Validators.required]],
    ind_instancia : [null]
  });

  json_aplicaciones : any;
  ind_sinlimite : boolean = false;
  err_usr_permitidos : boolean = true;
  json_modulos : any;

  json_accesos_disponibles : any ;
  ind_add_accion :boolean = true;
  ind_add_menu : boolean = true;

  data_accesos = [];
  data_post_accesos :any ={'menu' : {}, 'acciones' : {}}; //informacion de los menus y acciones que se adicionaran.

  /*variables para tabla */
  recurso : string ;
  columns = ['descripcion', 'modulo', 'tipo', 'acciones'];
  params  : any;
  nombre_tabla :string = 'accesos-contrato';
  target ;
  /** */


  constructor(private fb: FormBuilder,    
              private mod_serv : ModuloService, 
              public contrato_serv : ContratoService,
              private tb_serv : TablesService,
              private msj_serv : MensajeService) {}

  ngOnInit(): void {

    this.contrato_serv
        .consultar_aplicaciones()    
        .then(
          ()=>{

            this.json_aplicaciones = this.contrato_serv.json_apliciones;

          }
        );

    this.llenar_forma();   
    this.target = document.querySelector('#btn_aceptar_contratoapp');
    
  }

  onSubmit() {

    let usr_permitidos = +this.contratoappForm.get('num_cantidad_usuarios').value;
    this.ind_sinlimite = this.contratoappForm.get('ind_sin_limite').value;
    
    if((!usr_permitidos || usr_permitidos < 1) && !this.ind_sinlimite){
      this.err_usr_permitidos = true;
      this.msj_serv.ver_mensaje('Debe ingresar la cantidad de usuarios permitidos.', '', this.msj_serv.TIPO_ERROR);
      return;
    }

    let value = this.contratoappForm.value;
    let value_form ={

      fk_contrato : value.fk_contrato,
      fk_aplicacion : value.fk_aplicacion,
      num_cantidad_usuarios : value.num_cantidad_usuarios,
      ind_sin_limite : value.ind_sin_limite?true : false,
      ind_full_acceso : value.ind_full_acceso?true : false,
      short_name : value.short_name,
      ind_instancia : value.ind_instancia ? 1 : 0

    }

    if (value_form.ind_sin_limite == null || value_form.ind_sin_limite == undefined){
      value_form.ind_sin_limite = false;
    }

    if (this.contrato_serv.json_contrato.json_aplicacion && this.contrato_serv.json_contrato.json_aplicacion.id_aplicacion){
      this.actualizar_app(value_form)
    }else{
      this.asociar_app(value_form);
    }
    this.err_usr_permitidos = false;

    
  }

  /**
   * asocia el app a un contrato.
   * @param value_form 
   */
  asociar_app(value_form){

    value_form.num_cantidad_usuarios = value_form.num_cantidad_usuarios == null? 0 : value_form.num_cantidad_usuarios;
    this.contrato_serv.asociar_app(value_form, this.data_post_accesos);

  }

  /**
   * 
   * @param value_form Actulizar el app de un contrato
   */
  actualizar_app(value_form){
    this.contrato_serv 
        .actualizar_appcontrato(value_form, this.data_post_accesos);
  }


  /**
   * Evento cambio checkbox sin limite.
   */
  change_sinlimite(){

    this.contratoappForm.get('num_cantidad_usuarios').setValue(0);
    this.ind_sinlimite = this.contratoappForm.get('ind_sin_limite').value;

  }

  llenar_forma(){

    let json_app : AppContrato = this.contrato_serv.json_contrato.json_aplicacion;

    this.contratoappForm.get('fk_contrato').setValue(this.contrato_serv.json_contrato.id_contrato);

    if (json_app && json_app.id_aplicacion){
      this.contratoappForm.get('fk_aplicacion').setValue(json_app.id_aplicacion);
      this.contratoappForm.get('ind_sin_limite').setValue(json_app.ind_sin_limite);
      this.change_sinlimite();
      this.contratoappForm.get('ind_full_acceso').setValue(!!json_app.ind_full_acceso ? json_app.ind_full_acceso : false);
      this.contratoappForm.get('num_cantidad_usuarios').setValue(json_app.num_cantidad_usuarios);
      this.contratoappForm.get('short_name').setValue(json_app.short_name);
      this.contratoappForm.get('ind_instancia').setValue(json_app.ind_instancia);
      

      this.mod_serv
        .consultar_modulos(json_app.id_aplicacion)
        .then(()=>{this.json_modulos = this.mod_serv.modulos;}); 
    }

    if(this.contrato_serv.disabled){
      this.contratoappForm.disable()
    }

  }

  /**
   * Consulta los accessos de un contrato a la aplicacion.
   */
  consultar_accesos(){

    if (this.contratoappForm.get('fk_modulo').value >= 0){

      let id_contrato = String(this.contrato_serv.json_contrato.id_contrato);
      let id_modulo = String(this.json_modulos[this.contratoappForm.get('fk_modulo').value].id_modulo_app);
      //accesos disponibles para adicionar.
      this.contrato_serv
          .consultar_accesos(id_contrato,'0','1',id_modulo,'1')
          .then(
            ()=>{
              this.json_accesos_disponibles = this.contrato_serv.json_accesos_disponibles;
              this.contratoappForm.get('fk_accion').setValue('');
              this.contratoappForm.get('fk_menu').setValue('');
  
              this.ind_add_menu = this.json_accesos_disponibles.menu_disponibles ? false : true;
              this.ind_add_accion = this.json_accesos_disponibles.acciones_disponibles ? false : true;
            }
          );
  
      this.accesos_adicionados();
    }
    
  }

  /**
   * 
   * @param tipo_acceso tipo de accesos que se adicionara 1 menu, 2 accion
   */
  add_acceso(tipo_acceso : number){

    let tipo = '';
    let item ;
    let acciones = [];
    let menu = (''+this.contratoappForm.get('fk_menu').value).trim();
    let accion = (''+this.contratoappForm.get('fk_accion').value).trim();
    let ind_seleccionado = menu.length ||  accion.length;
    
    if (ind_seleccionado) {
      if (tipo_acceso == 1){

        tipo    = 'Menu';
        item   =  this.json_accesos_disponibles.menu_disponibles[this.contratoappForm.get('fk_menu').value];

        if(!this.data_post_accesos['menu'][item.id_opcion_menu]){
          this.data_post_accesos['menu'][item.id_opcion_menu] = true
        }

        acciones.push(
          {
            'ind_check': true,
            'value' : item.ind_activo,
            'function': 'cambiar_acceso',
            'params' : {'tipo' : 1 , 'id_opcion_menu' : item.id_opcion_menu }
          }
        );

        this.contratoappForm.get('fk_menu').setValue('');
      }else{
        tipo    = 'Accion.';
        item   =  this.json_accesos_disponibles.acciones_disponibles[this.contratoappForm.get('fk_accion').value];

        if(!this.data_post_accesos['acciones'][item.id_accion]){
          this.data_post_accesos['acciones'][item.id_accion] = true
        }

        acciones.push(
          {
            'ind_check': true,
            'value' : item.ind_activo,
            'function': 'cambiar_acceso',
            'params' : {'tipo' : 2 , 'id_accion' : item.id_accion }
          }
        );

        this.contratoappForm.get('fk_accion').setValue('');
      }

      let json_item = {
        'descripcion' :item.txt_descripcion,
        'modulo' : this.json_modulos[this.contratoappForm.get('fk_modulo').value].txt_descripcion,
        'tipo' : tipo,
        'acciones' : acciones
      }

      if(!this.validar_exitencia_acceso(json_item)){
        this.data_accesos.push(json_item);
      }
      this.tb_serv.tablas[this.nombre_tabla].data_offline(this.data_accesos);
    } else {
      const mensaje = 'Debe seleccionar una opcion para poder ' + (tipo_acceso === 1 ? 'adicionar acceso al menu' : 'adicionar acceso a la accion');
      this.msj_serv.ver_mensaje(mensaje, '', 3);
    }


  }

  accesos_adicionados(){
    let id_contrato = String(this.contrato_serv.json_contrato.id_contrato);
    let id_modulo = String(this.json_modulos[this.contratoappForm.get('fk_modulo').value].id_modulo_app);
    //accesos disponibles para adicionar.
    this.contrato_serv
        .consultar_accesos(id_contrato,'1','1',id_modulo,'1')
        .then(
          ()=>{

            let acciones = this.contrato_serv.json_accesos_adicionados.acciones_adicionadas;
            let menus = this.contrato_serv.json_accesos_adicionados.menu_adicionados;

            acciones?.forEach(element => {

              let item = {
                'descripcion' :element.txt_descripcion, 
                'modulo' : element.txt_modulo,
                'tipo' : element.txt_tipo,
                'acciones' : [
                  {
                    'ind_check': true,
                    'value' : element.ind_activo,
                    'function': 'cambiar_acceso',
                    'params' : {'tipo' : 2 , 'id_accion' : element.id_accion }
                  }
                ] 
              };
              
              if (!this.validar_exitencia_acceso(item)){
                this.data_accesos.push(item);
              }

              if(!this.data_post_accesos['acciones'][element.id_accion]){
                this.data_post_accesos['acciones'][element.id_accion] = true
              }
              
            });

            menus?.forEach(element => {

              let item = {
                'descripcion' :element.txt_descripcion, 
                'modulo' : element.txt_modulo,
                'tipo' : element.txt_tipo,
                'acciones' : [
                  {
                    'ind_check': true,
                    'value' : element.ind_activo,
                    'function': 'cambiar_acceso',
                    'params' : {'tipo' : 1 , 'id_opcion_menu' : element.id_opcion_menu }
                  }
                ]
              }
              
              if (!this.validar_exitencia_acceso(item)){
                this.data_accesos.push(item);
              }

              if(!this.data_post_accesos['menu'][element.id_opcion_menu]){
                this.data_post_accesos['menu'][element.id_opcion_menu] = true
              }
              
            });

            this.tb_serv.tablas[this.nombre_tabla].data_offline(this.data_accesos);
            
            
          }
        );
    
  }

  /**
   * Activa o inactiva  el acceso
   */
  @HostListener('cambiar_acceso')
  cambiar_acceso(){
    let params = this.tb_serv.params_event;

    if (params.tipo ==1){
      this.data_post_accesos['menu'][params.id_opcion_menu ] =  !this.data_post_accesos['menu'][params.id_opcion_menu ];
    }else{
      this.data_post_accesos['acciones'][params.id_accion ] =  !this.data_post_accesos['acciones'][params.id_accion ];
    }
  }

  consultar_modulos() {
    
    const idApp = this.contratoappForm.get('fk_aplicacion').value;
    this.mod_serv
        .consultar_modulos(idApp)
        .then( () => {
          this.json_accesos_disponibles = null;
          this.ind_add_menu =  true;
          this.ind_add_accion =  true;
          this.json_modulos = this.mod_serv.modulos;
          this.contratoappForm.get('fk_modulo').setValue('');
          this.contratoappForm.get('fk_accion').setValue('');
          this.contratoappForm.get('fk_menu').setValue('');
        });
  }

  /**
   * valida si el item existe en el array de accesos
   * @param item item a buscar
   */
  validar_exitencia_acceso(item){
    let existe :boolean = false;
    let b = JSON.stringify(item);

    this.data_accesos.forEach(
      acc =>{
        let a = JSON.stringify(acc);

        if ( a == b){
          existe = true;
        }
      }
    );

    return existe;
  }
}
